module.exports = __webpack_public_path__ + "static/media/shop-disabled.bbebabb7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/bottomNavigation/shop-disabled.svg
// module id = 2253
// module chunks = 0